var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"heart"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"heart","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Path-15","transform":"translate(6.000000, 6.000000)","fill":"#73C9BD"},React.createElement("polygon",{"id":"Path-13","points":"2.80904523 12 1.11055276 9.65217391 0 6.58695652 0 3.91304348 1.43718593 1.5 3.52763819 0 5.42211055 0.586956522 6.92462312 2.15217391 6.92462312 4.63043478 8.49246231 3.19565217 10.3869347 3.19565217 11.4974874 3.91304348 13 5.41304348 12.5427136 7.10869565 11.9547739 8.80434783 10.3869347 10.5 6.92462312 11.6086957"})))]);
}

Heart.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Heart;

Heart.default = Heart;
